import { LocationOn } from '@mui/icons-material';
import { SearchBar } from '@practium/ui';
import { ALL_STATE_CODES } from '../../constants/parameters.constants';
import { STATE_NAMES } from '../../constants/stateNames';
import { StateMiniMapSVG } from '../Map/BrazilMap/StateMiniMapSVG';
import styles from './EditRegionLeftPanel.module.css';

interface EditRegionLeftPanelProps {
	selectedStateCodes: string[];
	unavailableStateCodes: string[];
	searchQuery: string;
	onSearchChange: (query: string) => void;
	onToggleState: (code: string) => void;
}

export const EditRegionLeftPanel = ({
	selectedStateCodes,
	unavailableStateCodes,
	searchQuery,
	onSearchChange,
	onToggleState,
}: EditRegionLeftPanelProps) => {
	const query = searchQuery.toLowerCase();
	const filteredStates = ALL_STATE_CODES.filter(
		(code) => code.toLowerCase().includes(query) || (STATE_NAMES[code] ?? '').toLowerCase().includes(query)
	);

	return (
		<div className={styles.panel}>
			<div className={styles.statesBtn}>
				<LocationOn sx={{ fontSize: '1.125rem' }} />
				<span>Estados</span>
			</div>

			<SearchBar value={searchQuery} onChange={onSearchChange} />

			<div className={styles.statesGrid}>
				{filteredStates.map((code) => {
					const isSelected = selectedStateCodes.includes(code);
					const isUnavailable = unavailableStateCodes.includes(code);
					return (
						<div
							key={code}
							className={`${styles.stateCard} ${isUnavailable ? styles.stateCardUnavailable : ''}`}
							onClick={() => !isUnavailable && onToggleState(code)}
							role="button"
							tabIndex={isUnavailable ? -1 : 0}
							onKeyDown={(e) => e.key === 'Enter' && !isUnavailable && onToggleState(code)}
							aria-pressed={isSelected}
							aria-disabled={isUnavailable}
						>
							<div className={`${styles.stateContainer} ${isSelected ? styles.stateContainerSelected : ''}`}>
								<div className={styles.stateMapWrapper}>
									<StateMiniMapSVG stateCode={code} isSelected={isSelected} />
								</div>
							</div>
							<span className={styles.stateLabel}>{STATE_NAMES[code] ?? code}</span>
							{isUnavailable && <span className={styles.stateHint}>Em outra região</span>}
						</div>
					);
				})}
			</div>
		</div>
	);
};
